import apiClient from "../../utils/apiClient";

/**
 * Identity-card calls.
 *
 * `verifyCard` is the odd one: it is the only call in the app that must work
 * with NO credentials, because it is what a printed QR opens on a stranger's
 * phone at a gate. `apiClient` attaches an Authorization header when one exists
 * in localStorage, which the server ignores on this route — but the route must
 * never come to depend on it.
 */

export const errorText = (err, fallback = "Something went wrong. Please try again.") =>
  err?.response?.data?.message || err?.message || fallback;

/** The caller's own card. */
export const fetchMyCard = () =>
  apiClient.get("/identity-card/me").then((r) => r.data);

/** A student's card, for staff printing one. */
export const fetchStudentCard = (studentId) =>
  apiClient.get(`/identity-card/student/${studentId}`).then((r) => r.data);

/** Public verification — what the QR resolves to. No auth required. */
export const verifyCard = (token) =>
  apiClient.get(`/public/identity-card/${encodeURIComponent(token)}`).then((r) => r.data);
